import React from 'react';
import {
  Button, Row, Col, Icon, Dropdown
  , Menu, Table, Spin, Checkbox, message
} from 'antd';
import { inject, observer } from 'mobx-react';
import AppDatasBody from '../util/AppDatasBody';
import AppAddModal from '../util/AppAddModal';
import AppApplyModal from '../util/AppApplyModal';
import Navigation from '../public/navigation';
import CSRadioGroup from '../public/cs-radio-group';
import { toJS } from 'mobx';
import util from '../../util';
const { isWeaver } = util;
const isweaver = isWeaver();

const store = [
  'collectStore',
  'homeStore',
  'listStore',
  'modeListStore',
]

@inject(...store)
@observer
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
    }
  }

  componentDidMount() {
    const { listStore, homeStore, location } = this.props;
    let { showStyle } = listStore;
    listStore.getRoutes(location.query);
    listStore.callScreenData(homeStore.type.id, location.query);
    if (!showStyle)
      listStore.callAppData(homeStore.type.id,
        {
          trade: location.query.radioItem || '',
          function: location.query.radioSubItem || ''
        });
    listStore.rowSelection = { selectedRowKeys: [], selectedRows: [] };
    listStore.selected = false;
    listStore.selectedApps = [];
  }

  componentWillUnmount() {
    const { listStore } = this.props;
    listStore.appDatas = [];
  }

  getFunctions = () => {
    const { listStore, homeStore } = this.props;
    let { func_radios, func_radios_len, params, showStyle, callAppData2 } = listStore;
    func_radios = toJS(func_radios);
    if (showStyle && func_radios[0] && func_radios[0].defaultValue === '0') {
      for (let i = func_radios_len - 1; i < func_radios_len + 2 && i < func_radios[0].data.length; i++) {
        params.function = func_radios[0].data[i].g_id;
        params.trade = func_radios[0].data[i].g_tradeid;
        listStore.params = params;
        callAppData2(homeStore.type.id, params, true);
      }
    }
  }

  //添加下拉框点击
  handleMenuClick(e) {
    const { listStore } = this.props;
    let { rowSelection, showStyle, selectedApps } = listStore;
    rowSelection = toJS(rowSelection);
    selectedApps = toJS(selectedApps);
    let s_ids = [];
    if (!showStyle) {
      rowSelection.selectedRows && rowSelection.selectedRows.forEach(item => {
        if (item.tms_iscoll === '1') s_ids.push(item.sw_id);
      })
    } else {
      selectedApps.forEach(item => {
        item.data.forEach(o => {
          if (o.tms_iscoll === '1') s_ids.push(o.sw_id);
        })
      })
    }
    if (e.key !== '') {
      if (e.key === '1') {
        if (s_ids.toString() !== '') listStore.callCollect({ s_ids: s_ids.toString() }, 'collect');
        else {
          message.info('选中的流程表单均已收藏');
        }
      } else {
        listStore.callAddWhereData();
        listStore.addModal = { ...listStore.addModal, addWhere: e.key, visible: true };
      }
    }
  }

  //添加应用确认
  handleOk(key, name, type) {
    const { listStore } = this.props;
    listStore.callToAddAPP("??todo:所选应用id", key)
    listStore.addModal = { ...listStore.addModal, visible: false };
  }

  isSelectedAll() {
    const { listStore } = this.props;
    let { appDatas, rowSelection } = listStore;
    rowSelection = toJS(rowSelection);
    let currentDatas = toJS(appDatas);
    let intersection = rowSelection.selectedRows.filter(v => {
      let temp = currentDatas.filter(o => {
        return o.sw_id === v.sw_id;
      });
      return temp.length !== 0;
    });
    listStore.selected = intersection.length === currentDatas.length;
  }

  selectPage() {
    let { listStore, homeStore } = this.props;
    const { callAppData } = listStore;
    listStore.params.current += 1;
    callAppData(homeStore.type.id, listStore.params);
  }

  previewApp(v) {
    let { listStore } = this.props;
    listStore.previewApp(v);
    v && v.hpid
      ? window.open("http://203.110.166.54:8085/homepage/Homepage.jsp?subCompanyId=25&showbtn=0&isfromportal=1&hpid=" + v.hpid)
      : window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + v.s_wfid)
  }

  collect(v) {
    const { listStore } = this.props;
    let param = { s_ids: v.sw_id };
    listStore.callCollect(param, 'collect');
  }

  apply(v) {
    const { homeStore } = this.props;
    let param = { sw_id: v.sw_id, s_id: v.s_id };
    let appInfo = [];
    appInfo.push({ appId: v.s_number, appName: v.s_name });
    homeStore.callApply(param, appInfo);
  }

  handleApplyClick() {
    const { listStore, homeStore } = this.props;
    let { rowSelection, showStyle, selectedApps } = listStore;
    rowSelection = toJS(rowSelection);
    selectedApps = toJS(selectedApps);
    let sw_id = [], s_id = [], appInfo = [], param = {};
    if (!showStyle) {
      rowSelection.selectedRows.forEach(item => {
        sw_id.push(item.sw_id);
        s_id.push(item.s_id);
        appInfo.push({ appId: item.s_number, appName: item.s_name });
      });
    } else {
      selectedApps.forEach(item => {
        item.data.forEach(o => {
          sw_id.push(o.sw_id);
          s_id.push(o.s_id);
          appInfo.push({ appId: o.s_number, appName: o.s_name });
        })
      })
    }
    param = { sw_id: sw_id.toString(), s_id: s_id.toString() };
    homeStore.callApply(param, appInfo);
  }

  //-----------------------------------流程表单~行业、职能关联查询--------------------------------------------------------
  getRadioGroup = (item) => {
    const { listStore, homeStore } = this.props;
    let {
      func_radios, sreenDatas, params, showStyle
      , setAppDatas2, setAppDatas, setSreenDatas, callAppData
      , callAppData2, setMobxState,
    } = listStore;
    func_radios = toJS(func_radios);
    sreenDatas = toJS(sreenDatas);
    sreenDatas = toJS(sreenDatas);
    params = toJS(params);
    return (
      <div key={item.key}>
        {/* {
          location.query.id === 'all' && (
            <div
              className={`list-radio-type-name ${index !== 0 && 'list-radio-type-name2'}`}
            >{item.name}</div>
          )
        } */}
        <CSRadioGroup datas={toJS(item.data)}
          onChange={(obj, itemNew) => {
            //设置radioGroup筛选数据
            setMobxState({ selectedApps: [], selected: false });
            let tempData = [], allFunc = {};
            sreenDatas.forEach(temp => {
              temp.data.forEach(v => {
                if (v.key === itemNew.key) {
                  v.defaultValue = itemNew.defaultValue;
                  v.data.forEach(o => {
                    allFunc = o.funcList[0];
                    tempData = tempData.concat(o.funcList.slice(1));
                    if (o.g_id === v.defaultValue) {
                      func_radios[0].defaultValue = '0';
                      func_radios[0].data = o.funcList;
                      setMobxState({ func_radios });
                    }
                  })
                }
              });
            });
            if (itemNew.defaultValue === '0') {
              func_radios[0].defaultValue = '0';
              tempData.unshift(allFunc);
              func_radios[0].data = tempData;
              setMobxState({ func_radios });
            }
            setSreenDatas(sreenDatas);

            if (!showStyle) {
              //查询应用1 table列表格式
              setAppDatas([]);
              if (itemNew.key === 'function') {
                params.function = obj.target.value;
              } else if (itemNew.key === 'trade') {
                params.trade = obj.target.value !== '0' ? obj.target.value : '';
                params.function = '';
              }
              setMobxState({params});
              callAppData(homeStore.type.id, params);
            } else {
              //查询应用2 按照行业、职能划分
              setMobxState({ func_radios_len: 1 });
              setAppDatas2([]);
              func_radios[0] && func_radios[0].data.forEach((item, index) => {
                if (index > 0 && index <= 3) {
                  params.function = item.g_id;
                  params.trade = item.g_tradeid;
                  setMobxState({params});
                  callAppData2(homeStore.type.id, params, true);
                }
              })
            }
          }}
        />
        {
          func_radios.length !== 0 &&
          <CSRadioGroup datas={func_radios}
            onChange={(obj, itemNew) => {
              func_radios[0].defaultValue = obj.target.value;
              params.function = obj.target.value !== '0' ? obj.target.value : '';
              setMobxState({ selectedApps: [], selected: false, func_radios, params });
              if (obj.target.value === '0') {
                params.trade = sreenDatas[0].data[0].defaultValue;
                setMobxState({ params });
              } else {
                itemNew.data.forEach(o => {
                  if (o.key === obj.target.value) {
                    params.trade = o.g_tradeid;
                    setMobxState({ params });
                  }
                })
                sreenDatas[0].data[0].data.forEach(temp => {
                  if (temp.key === params.trade) {
                    func_radios[0].data = temp.funcList;
                    setMobxState({ func_radios });
                  }
                })
              }
              sreenDatas[0].data[0].defaultValue = params.trade;
              setMobxState({ sreenDatas });
              if (!showStyle) {
                //查询应用1 table列表格式
                setAppDatas([]);
                callAppData(homeStore.type.id, params);
              } else {
                //查询应用2 按照行业、职能划分
                setMobxState({ func_radios_len: 1 });
                setAppDatas2([]);
                if (obj.target.value === '0') {
                  func_radios[0] && func_radios[0].data.forEach((item, index) => {
                    if (index > 0 && index <= 3) {
                      params.function = item.g_id;
                      params.trade = item.g_tradeid;
                      setMobxState({ params });
                      callAppData2(homeStore.type.id, params, true);
                    }
                  })
                } else {
                  callAppData2(homeStore.type.id, params, false);
                }
              }
            }} />
        }
      </div>
    );
  }
  //-------------------------------------------------------------------------------------------------------------------

  //-----------------------------------流程表单~排序[热度、更新日期、发布日期~排列[表格或按照行业、职能划分]-----------
  getApp2(type = 0) {
    const { listStore, homeStore } = this.props;
    let {
      setShowStyle, params, func_radios, setAppDatas2
      , callAppData2
    } = listStore;
    func_radios = toJS(func_radios);
    setShowStyle(true);
    setAppDatas2([]);
    listStore.selectedApps = [];
    listStore.selected = false;
    listStore.func_radios_len = 1;
    if (type !== 0) params.type = type;
    let func = func_radios[0] && func_radios[0].defaultValue;
    if (func !== '0') {
      params.function = func_radios[0].defaultValue;
      func_radios[0].data.forEach(item => {
        if (item.key === func_radios[0].defaultValue) {
          params.trade = item.g_tradeid;
        }
      })
      callAppData2(homeStore.type.id, params, false);
    }
    else {
      if (params.wfstyle === 0) {
        func_radios[0] && func_radios[0].data.forEach((item, index) => {
          if (index > 0 && index <= 3) {
            params.function = item.g_id;
            params.trade = item.g_tradeid;
            listStore.setMobxState({ params });
            callAppData2(homeStore.type.id, params, true);
          }
        });
      } else {
        listStore.setMobxState({ params });
        callAppData2(homeStore.type.id, params, true);
      }
    }
  }

  //-------------------------------------------------------------------------------------------------------------------

  render() {
    const server = window.server;
    let that = this;
    let { listStore, location, homeStore, homeStore: { setType }, modeListStore: { searchType } } = this.props;
    let {
      routes, appDatas, routing, orderBy
      , rowSelection, loading, sort, showStyle
      , setShowStyle, params, appDatas2, sreenDatas
      , func_radios, setAppDatas2, setSelectedApps
      , selectedApps, setSelectedAllApps, setAppDatas
      , callAppData2, callAppData, showMore, sortDefaultIndex
    } = listStore;
    appDatas = toJS(appDatas);
    rowSelection = toJS(rowSelection);
    appDatas2 = toJS(appDatas2);
    sreenDatas = toJS(sreenDatas);
    func_radios = toJS(func_radios);
    selectedApps = toJS(selectedApps);

    //---------------------------------判断当前表单是否有选中的值----------------------------------------------
    let disabledList = true;
    selectedApps.forEach(item => {
      if (item.data.length !== 0) disabledList = false;
    })
    let disabledCollect = rowSelection.selectedRows.length === 0;
    let needCollect = false;
    rowSelection.selectedRows.forEach(item => {
      if (item.tms_iscoll === '1') needCollect = true;
    });
    if (!needCollect) disabledCollect = true;
    //---------------------------------------------------------------------------------------------------
    const menu = (
      <Menu onClick={this.handleMenuClick.bind(this)}>
        <Menu.Item key="1" disabled={disabledCollect || !isweaver}>我的收藏</Menu.Item>
        {/*<Menu.Item key="2" disabled={selectedRows.length === 0}>我的项目</Menu.Item>*/}
        {/* <Menu.Item key="3" disabled={selectedRows.length === 0}>我的方案</Menu.Item>*/}
      </Menu>
    );
    const menuList = (
      <Menu onClick={this.handleMenuClick.bind(this)}>
        <Menu.Item key="1" disabled={disabledList || !isweaver}>我的收藏</Menu.Item>
        {/*<Menu.Item key="2" disabled={selectedRows.length === 0}>我的项目</Menu.Item>*/}
        {/* <Menu.Item key="3" disabled={selectedRows.length === 0}>我的方案</Menu.Item>*/}
      </Menu>
    );
    const columns = [
      {
        key: '1',
        title: '表单名称',
        dataIndex: 'name',
        render(text, record, index) {
          return (
            <div>
              <div style={{ display: 'inline-block' }}>
                <img className='list-table-img'
                  src={server + record.s_pictureNati} alt='' />
              </div>
              <div className='list-table-record' style={{ display: 'inline-block' }}>
                <div style={{ fontWeight: 600, cursor: 'pointer' }}
                  onClick={() => {
                    // routing.push({
                    //   pathname: '/app/listapp',
                    //   query: {
                    //     id: location.query.id,
                    //     application: location.query.application,
                    //     radioType: location.query.radioType,
                    //     radioItem: location.query.radioItem,
                    //     project: location.query.project || '0',
                    //     scheme: location.query.scheme || '0',
                    //     list: record.key,
                    //   }
                    // })
                    // window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + record.s_wfid);
                  }}>{record.s_name}</div>
                <div className='list-table-record-sub'>
                  <span>
                    <Icon type="eye-o" />
                    <span>{record.s_count} 次</span>
                  </span>
                  <span>
                    <Icon type="download" />
                    <span style={{ color: '#ffab65' }}>{record.tms_isbuy_count}</span> 次
                  </span>
                  <span className='list-table-func'>{record.s_tradeName}</span>
                  <span className='list-table-func'>{record.s_funName}</span>
                </div>
              </div>
            </div>
          )
        }
      },
      {
        key: '2',
        title: '操作',
        width: 180,
        render(text, record) {
          return (
            <div>
              {
                record && record.hpid
                  ? <span className='list-table-btn'
                    style={{cursor:'not-allowed'}}
                    onClick={() => {
                      // window.open("http://203.110.166.54:8085/homepage/Homepage.jsp?showbtn=0&subCompanyId=25&isfromportal=1&hpid=" + record.hpid)
                    }
                    }>
                    预览</span>
                  : <span className='list-table-btn'
                    style={{cursor:'not-allowed'}}
                    onClick={() => {
                      // that.previewApp(record);
                    }}>
                    预览</span>
              }
              <span className={`list-table-btn ${!isweaver && 'cs-btn-disabled'}`}
                onClick={() => {
                  if (isweaver) {
                    let param = { sw_id: record.sw_id, s_id: record.s_id };
                    let appInfo = [];
                    appInfo.push({ appId: record.s_number, appName: record.s_name });
                    homeStore.callApply(param, appInfo);
                  }
                }}>申请</span>
              <span className={`list-table-btn ${!isweaver && 'cs-btn-disabled'}`}
                onClick={() => {
                  if (isweaver) {
                    let param = { s_ids: record.sw_id };
                    listStore.callCollect(param, record.tms_iscoll === '1' ? 'collect' : 'remove');
                  }
                }}>
                {
                  record.tms_iscoll === '1' ? '收藏' : '取消收藏'
                }
              </span>
            </div>
          )
        }
      }
    ];
    const isSearch = location.pathname === 'app/search';
    return (
      <div className='list' style={{backgroundColor: '#f0f4f8'}}>
        <AppDatasBody layout={{span: 24}} location={location}>
          {
            !isSearch && (
              <Navigation datas={toJS(routes)} onClick={
                (obj) => {
                  if (obj.path !== '/')
                    routing.push({
                      pathname: obj.path,
                      query: {
                        id: location.query.id,
                        application: location.query.application,
                        radioType: location.query.radioType,
                        radioItem: location.query.radioItem,
                        radioSubItem: location.query.radioSubItem,
                      }
                    });
                  else {
                    routing.push('/');
                    setType('all', '全部应用');
                  }
                }} />
            )
          }
          <CSRadioGroup datas={toJS(sort[sortDefaultIndex])}
            onChange={obj => {
              listStore.selectedApps = [];
              listStore.sort[sortDefaultIndex][0].defaultValue = obj.target.value;
              params.wfstyle = obj.target.value === 'workflow' ? 0 : 1;
              listStore.params = params;
              if (!showStyle) {
                setAppDatas([]);
                callAppData(homeStore.type.id, params, false);
              }
              else {
                setAppDatas2([]);
                if (obj.target.value === 'workflow') {
                  listStore.setMobxState({ func_radios_len: 2 });
                  this.getFunctions();
                } else {
                  listStore.setMobxState({ func_radios_len: 1 });
                  callAppData2(homeStore.type.id, params, true);
                }
              }
            }} />
          {
            sreenDatas && sreenDatas.map((item, index) => {
              let id = location.query.id;
              if (id === 'all') id = searchType;
              if (item.key === id && sort[sortDefaultIndex][0].defaultValue === item.key) {
                return (
                  this.getRadioGroup(item, index)
                )
              }
            })
          }
          <Row className="cs-tool list-tool">
            <Col span={14} className="cs-tool-order">
              <a className={`${orderBy === '0' && 'cs-order-active'}`}
                onClick={() => {
                  listStore.orderBy = '0';
                  if (!showStyle) {
                    setAppDatas([]);
                    listStore.selectedApps = [];
                    callAppData(homeStore.type.id, { type: 1 });
                  } else {
                    this.getApp2(1);
                  }
                }}>热度</a>
              <a className={`${orderBy === '1' && 'cs-order-active'}`}
                onClick={() => {
                  listStore.orderBy = '1';
                  if (!showStyle) {
                    setAppDatas([]);
                    listStore.selectedApps = [];
                    callAppData(homeStore.type.id, { type: 3 });
                  } else {
                    this.getApp2(3);
                  }
                }}>更新日期</a>
              <a className={`${orderBy === '2' && 'cs-order-active'}`}
                onClick={() => {
                  listStore.orderBy = '2';
                  if (!showStyle) {
                    setAppDatas([]);
                    listStore.selectedApps = [];
                    callAppData(homeStore.type.id, { type: 2 });
                  } else {
                    this.getApp2(2);
                  }
                }}>发布日期</a>
              {
                !showStyle && (
                  <div style={{ display: 'inline-block', padding: '6px 0' }}>
                    <Button style={{ marginRight: 10 }}
                      onClick={this.handleApplyClick.bind(this)}
                      disabled={rowSelection.selectedRows.length === 0 || !isweaver}
                    >批量申请</Button>
                    <Dropdown overlay={menu}>
                      <Button>
                        批量添加至 <Icon type="down" />
                      </Button>
                    </Dropdown>
                  </div>
                )
              }
            </Col>
            <Col span={10} className="cs-tool-op">
              <div className='list-style'>
                <div className='list-style-div' onClick={() => {
                  setShowStyle(false);
                  setAppDatas([]);
                  params.trade = sreenDatas[0].data[0].defaultValue;
                  params.function = func_radios[0].defaultValue;
                  if (params.trade === '0') params.trade = '';
                  if (params.function === '0') params.function = '';
                  callAppData(homeStore.type.id, params);
                }}>
                  <div className={`icon-Cloud-List list-style-icon ${!showStyle && 'list-style-icon-active'}`} />
                </div>
                <div className='list-style-div'
                  onClick={() => { this.getApp2() }}>
                  <div className={`icon-Cloud-Tile list-style-icon ${showStyle && 'list-style-icon-active'}`} />
                </div>
              </div>
            </Col>
          </Row>
          <div>
            {
              loading && appDatas && appDatas.length === 0
                ? <div style={{ height: 600, backgroundColor: '#fff' }} />
                : !showStyle
                  ? (
                    <Table columns={toJS(columns)}
                      dataSource={appDatas}
                      className={`list-table  ${!showMore && 'list-table3'}`}
                      locale={{
                        emptyText:
                          <div style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.43)', textAlign: 'center' }}>
                            <Icon type="frown-o" />
                            <span style={{ marginLeft: 4 }}>暂无数据</span>
                          </div>
                      }}
                      pagination={false}
                      rowSelection={
                        {
                          type: 'checkbox',
                          onChange: (selectedRowKeys, selectedRows) => {
                            listStore.rowSelection = {
                              ...rowSelection,
                              selectedRowKeys: selectedRowKeys,
                              selectedRows: selectedRows
                            };
                          },
                          getCheckboxProps: () => ({
                            disabled: !isweaver,
                          })
                        }
                      }
                      rowClassName={record => {
                        let bool = false;
                        rowSelection.selectedRows.forEach(item => {
                          bool = record.s_id === item.s_id;
                        })
                        if (bool) return 'list-table2';
                        else return '';
                      }}
                    />
                  )
                  : (
                    <div>
                      <div className='list-btns'>
                        {
                          showStyle && (
                            <div style={{ display: 'inline-block' }}>
                              <Button style={{ marginRight: 10 }}
                                onClick={this.handleApplyClick.bind(this)}
                                disabled={disabledList || !isweaver}
                              >批量申请</Button>
                              <Dropdown overlay={menuList}>
                                <Button>
                                  批量添加至 <Icon type="down" />
                                </Button>
                              </Dropdown>
                            </div>
                          )
                        }
                      </div>
                      <div className={`list-apps-con2  ${!showMore && 'list-table3'}`}>
                        {
                          appDatas2 && appDatas2.map((item, index) => {
                            if (item.length !== 0) {
                              let indeterminate = false;
                              let checked = false;
                              selectedApps.forEach(o => {
                                if (o.trade === item.trade && o.function === item.function) {
                                  indeterminate = o.data.length !== 0 && o.data.length !== item.data.length;
                                  checked = o.data.length !== 0 && o.data.length === item.data.length;
                                }
                              })
                              return (
                                <div key={item.trade + '_' + item.function}
                                  className={`list-apps-con2-hover ${index % 2 !== 0 && 'list-apps-con2-1'}`}>
                                  <Row className='list-apps-con2-title'>
                                    <Col span={12}>
                                      {
                                        params.wfstyle === 0
                                          ? <div>
                                            <span key={item.tradeId}>{item.tradeName}—</span>
                                            <span key={item.functionId}>{item.functionName}({item.data.length})</span>
                                          </div>
                                          : <div>
                                            <span key={item.functionId}>样式 ({item.data.length})</span>
                                          </div>
                                      }
                                    </Col>
                                    <Col span={12} className='list-check-all'>
                                      <Checkbox
                                        indeterminate={indeterminate}
                                        checked={checked}
                                        disabled={!isweaver}
                                        onChange={(e) => {
                                          setSelectedAllApps(item, e.target.checked);
                                        }}><span>全选</span></Checkbox>
                                    </Col>
                                  </Row>
                                  <Row className='list-apps-con2-con'>
                                    {
                                      item.data.map((v, index) => {
                                        const isFirst = (index + 1) % 3 !== 1;
                                        return (
                                          <Col key={v.sw_id}
                                            span={6}
                                            offset={isFirst ? 3 : 0}>
                                            <div className='list-apps-con2-subcon'>
                                              <div className='list-apps-con2-subconl'>
                                                <Checkbox
                                                  checked={v.selected}
                                                  disabled={!isweaver}
                                                  onChange={(e) => {
                                                    setSelectedApps(item, v, e.target.checked);
                                                  }}>
                                                </Checkbox>
                                              </div>
                                              <div className='list-apps-con2-subcon-name'
                                                onClick={() => {
                                                  window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + v.s_wfid);
                                                }}>{v.s_name}</div>
                                            </div>
                                          </Col>
                                        )
                                      })
                                    }
                                  </Row>
                                </div>
                              )
                            }
                          })
                        }
                      </div>
                    </div>
                  )
            }
          </div>
          <Spin spinning={loading} style={{ marginTop: -12, marginLeft: 5 }}>
            <div className={showStyle ? 'list-more list-more-border' : 'list-more'} hidden={!showMore || (showStyle && params.wfstyle === 1)}>
              <div className='list-more-sub'>
                <span onClick={() => {
                  if (!showStyle) {
                    this.selectPage();
                  } else if(toJS(sort)[sortDefaultIndex][0].defaultValue === 'workflow') {
                    this.getFunctions();
                  }
                }}>查看更多</span>
                <Icon type="double-right" />
              </div>
            </div>
          </Spin>
          <AppAddModal addModal={listStore.addModal}
            location={location}
            appCatalog={this.props.params.type}//如果不同应用目录添加界面不同时用来区分(暂时不用)
            handleCloseModal={() => {
              listStore.addModal = { ...listStore.addModal, visible: false };
              listStore.rowSelectionAddModal = { ...listStore.rowSelectionAddModal, selectedRowsKey: [] };
              this.paginationAddModal = { ...this.paginationAddModal, current: 1 };
            }}
            handleOk={this.handleOk.bind(this)}
            onSearch={(params) => {
              listStore.callAddWhereData(listStore.addModal.addWhere, params)
            }}
          />

          <AppApplyModal applyModal={homeStore.applyModal}
            applyApps={homeStore.applyApps}
            // appCatalog={this.props.params.type}//如果不同应用目录添加界面不同时用来区分(暂时不用)
            handleCloseModal={() => {
              homeStore.applyModal = { ...homeStore.applyModal, visible: false }
            }}
          />
        </AppDatasBody>
      </div>
    )
  }
}

export default App

//图标排列方式
//
// <div className='list-apps-con'
// onMouseOut={() => {
//   listStore.appSelected = '';
// }}>
// {
//   appDatas && appDatas.map((item, index) => {
//       return (
//         <div
//           className={`app-content-single ${item.sw_id === appSelected && 'app-content-single-hover'}`}
//           key={item.sw_id}
//           onMouseOver={(e) => {
//             listStore.appSelected = item.sw_id;
//             e.stopPropagation && e.stopPropagation();
//             e.preventDefault && e.preventDefault();
//             e.nativeEvent && e.nativeEvent.preventDefault();
//           }} onMouseOut={() => {
//           this.setState({showDropdown: false});
//         }}>
//           <div className='app-content-single-con'>
//             <div className='app-content-single-img-con'>
//               <img src={server + item.s_pictureNati} alt=''
//                    onClick={() => {
//                      //   window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&gopage=/workflow/request/AddRequest.jsp?workflowid=" + item.s_wfid);
//                    }}/>
//             </div>
//             <div className='app-content-single-name' title={item.s_name}>{item.s_name}</div>
//             <div className='app-content-single-btns'>
//               <div className='app-content-single-btns'
//                    hidden={appSelected !== item.sw_id}
//               >
//                             <span className='app-content-single-btn'
//                                   onClick={() => {
//                                     window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&gopage=/workflow/request/AddRequest.jsp?workflowid=" + item.s_wfid);
//                                   }}>预览</span>
//                 <Icon type="minus" className='app-content-single-icon'/>
//                 <span className='app-content-single-btn'
//                       onClick={() => {
//                         this.apply(item);
//                       }}>申请</span>
//                 <Icon type="minus" className='app-content-single-icon'/>
//                 <span className='app-content-single-btn'
//                       onMouseOver={() => {
//                         this.setState({showDropdown: true})
//                       }}
//                       onMouseOut={() => {
//                         this.setState({showDropdown: false})
//                       }} style={{width: 80}}>
//                                   添加至 <Icon type="down"/>
//                                   <div className='app-dropdown-con'
//                                        onMouseOver={() => {
//                                          this.setState({showDropdown: true})
//                                        }}>
//                                     <div className='app-dropdown'>
//                                       <ul hidden={!this.state.showDropdown}>
//                                         <li key="1" onClick={() => {
//                                           this.collect(item);
//                                         }}>我的收藏
//                                         </li>
//                                         {/*<li key="2">我的项目</li>*/}
//                                         {/*<li key="3">我的方案</li>*/}
//                                       </ul>
//                                     </div>
//                                   </div>
//                                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       )
//     }
//   )
// }
// <div className='list-pagination'>
//   {
//     listStore.count > 20 && (
//       <Pagination current={params.current}
//                   total={listStore.count}
//                   pageSize={params.pageSize}
//                   onChange={(current) => {
//                     params.current = current;
//                     listStore.params = params;
//                     listStore.callAppData(homeStore.type.id, params);
//                   }}/>
//     )
//   }
//   {
//     listStore.count === 0 && (
//       <div style={{fontSize: 12, color: 'rgba(0, 0, 0, 0.43)', textAlign: 'center'}}>
//         <Icon type="frown-o"/>
//         <span style={{marginLeft: 4}}>暂无数据</span>
//       </div>
//     )
//   }
// </div>
// </div>

// window.onscroll = () => {
//   let dom = document.getElementsByClassName('home-footter')[0];
//   if (!!dom) {
//     //(屏幕可见高度+滚动条高度)>(页脚距离页面顶部的高度)——即当页面滚动，且可见页脚，加载更多数据
//     let innerHeight = window.innerHeight;//屏幕可见高度
//     let scrollHeight = 0;//滚动条高度
//     if (document.documentElement && document.documentElement.scrollTop) {
//       scrollHeight = document.documentElement.scrollTop;
//     } else if (document.body) {
//       scrollHeight = document.body.scrollTop;
//     }
//     let height = dom.offsetTop + document.body.scrollTop;//页脚距离页面顶部的高度
//     if (innerHeight + scrollHeight > height) {
//       this.getFunctions();
//     }
//     let com = document.getElementsByClassName('list-loading-tip')[0];
//     if (!!com) {
//       setTimeout(() => {
//         com.style.display = 'none';
//       }, 2000);
//     }
//   }
// }


// {/*<Dropdown overlay={*/}
// {/*(<Menu onClick={(e) => {*/}
// {/*if (e.key !== '') {*/}
// {/*if (e.key === '1') {*/}
// {/*let param = {s_ids: record.sw_id};*/}
// {/*homeStore.callCollect(param);*/}
// {/* listStore.callToAddAPP("??todo:所选应用id", e.key)*/}
// {/*} else {*/}
// {/*listStore.callAddWhereData();*/}
// {/*listStore.addModal = {...listStore.addModal, addWhere: e.key, visible: true};*/}
// {/*}*/}
// {/*}*/}
// {/*}}>*/}
// {/*<Menu.Item key="1">我的收藏</Menu.Item>*/}
// {/*/!*<Menu.Item key="2">我的项目</Menu.Item>*!/*/}
// {/*/!* <Menu.Item key="3">我的方案</Menu.Item>*!/*/}
// {/*</Menu>)}>*/}
// {/*<a>添加至 <Icon type="down"/></a>*/}
// {/*</Dropdown>*/}


// WEBPACK FOOTER //
// ./src/components/list/List.js